import React from 'react';
import Grid from '@mui/material/Grid';
import { Box, Button, FormControl, FormHelperText, Input, InputLabel, Stack, TextField, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';
import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs/components/prism-core';
// import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism.css'; //Example style, you can use another

import Service from '../../../util/Service';

const NodeSendTask = React.forwardRef((props, ref) => {
// export default function NodeSendTask(props) {
    const { item, processo } = props;

    const [code, setCode] = React.useState('<div/>');
    const [email, setEmail] = React.useState('%email%');
    const [assunto, setAssunto] = React.useState('%assunto%');
    const [corpo, setCorpo] = React.useState('Senhor(a) %nome%. \n<p>Corpo do email</p>.');

    React.useEffect(()=>{
        const tk = processo.lstTask.find( t => t.idTask === item.id);
        if( tk ){
            setCode( tk.codigo );
            setEmail( tk.dado.email);
            setAssunto( tk.dado.assunto);
            setCorpo( tk.dado.corpo);
        }else{
            buscaCodigo('sendEmailJs.txt');
        }
    },[])

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            salvar();
          }
    }))   

    function buscaCodigo(exemplo){
        if( !exemplo) return;
        Service.FETCH("/api/bpmn/buscaCodigoExemplo/"+exemplo) 
        .then(r => {
            setCode( r )
        });
    }

    const salvar = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            taskType: item.type,   
            dado:{
                email:email,
                assunto: assunto,
                corpo: corpo
            },
            codigo: code
        }        
        
        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
               
        }).catch(error => {
            console.error(error)
        })
    };
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
                <Grid size={6}>
                    {/* <Button onClick={salvar}>
                        Salvar
                    </Button>   */}
                    <Paper>
                        <Typography>Implemente a transformação</Typography>
                        <Editor
                            value={code}
                            onValueChange={t => setCode(t)}
                            highlight={code => {
                                // return( tipo === 'shell')?highlight(code, languages.bash):highlight(code, languages.js)
                                return highlight(code, languages.js)
                            }}
                            padding={10}
                            style={{
                                fontFamily: '"Fira code", "Fira Mono", monospace',
                                fontSize: 12,
                                minHeight: '400px'
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={6}>
                    <Paper sx={{ height:"100%" }}>                        
                        <Stack spacing={2}>
                            <Typography>Parametros do Email</Typography>
                            <FormControl>
                                <InputLabel htmlFor="my-input">Email para</InputLabel>
                                <Input id="e_email" aria-describedby="my-helper-text" value={email} onChange={(e)=> setEmail(e.target.value)}/>
                                {/* <FormHelperText id="my-helper-text">%user.email% -> para pegar de uma variavel no sistema.</FormHelperText> */}
                            </FormControl>
                            <FormControl>
                                <InputLabel htmlFor="my-input">Assunto</InputLabel>
                                <Input id="e_assunto" aria-describedby="my-helper-text" value={assunto} onChange={(e)=> setAssunto(e.target.value)}/>
                                {/* <FormHelperText id="my-helper-text">Pode ser composta por variavel de ambiente</FormHelperText> */}
                            </FormControl>
                            {/* <FormControl sx={{ height: '25ch' }}> */}
                                <InputLabel htmlFor="my-input">Corpo do email</InputLabel>
                                
                                <Editor
                                    value={corpo}
                                    onValueChange={t => setCorpo(t)}
                                    highlight={code => {
                                        // return highlight(code, languages.markup)
                                        return highlight(code, languages.js)
                                    }}
                                    padding={10}
                                    style={{
                                        fontFamily: '"Fira code", "Fira Mono", monospace',
                                        fontSize: 12,
                                        minHeight: '200px'
                                    }}
                                />
                                <FormHelperText id="my-helper-text">Pode ser composta por variavel de ambiente envolto emm %var%</FormHelperText>
                            {/* </FormControl> */}
                        </Stack>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    )

})

export default NodeSendTask;